export default function ({route, store}) {
  const breadcrumbsItem = route.meta.find(item => item.hasOwnProperty('breadcrumbs'));
  const breadcrumbs = breadcrumbsItem ? breadcrumbsItem.breadcrumbs : [];

  store.commit('setBreadCrumb', breadcrumbs)
}
